const code = '#Code\nprint("Hello World")';

export default code;
